const collectedStyles = () =>
    [...document.querySelectorAll("link[rel='stylesheet'], style")]
        .map((el) => el.outerHTML)
        .join("\n");

/**
 * Open a print preview for a DOM node (invoice / funding request).
 * Copies current page styles so SCSS classes still apply.
 */
export const openPrintDocument = async (root, title = "Print") => {
    if (!root) throw new Error("Nothing to print.");
    const win = window.open("", "_blank", "noopener,noreferrer");
    if (!win) throw new Error("Pop-up blocked. Allow pop-ups to print.");

    const safeTitle = String(title || "Print").replace(/[<>]/g, "");
    win.document.open();
    win.document.write(`<!DOCTYPE html>
<html>
<head>
    <meta charset="utf-8" />
    <title>${safeTitle}</title>
    ${collectedStyles()}
    <style>
        @page { margin: 0.6in; }
        body { background: #fff; }
    </style>
</head>
<body>${root.outerHTML}</body>
</html>`);
    win.document.close();

    await new Promise((resolve) => {
        const done = () => resolve();
        win.addEventListener("load", done, { once: true });
        setTimeout(done, 400);
    });

    win.focus();
    win.print();
};
